import { doc, getDoc, setDoc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';

const settingsRef = (db: Firestore, uid: string) => doc(db, 'users', uid, 'data', 'settings');

export async function loadYoutubeApiKey(db: Firestore, uid: string): Promise<string | null> {
  const snapshot = await getDoc(settingsRef(db, uid));
  if (!snapshot.exists()) return null;
  const value = snapshot.data().youtubeApiKey;
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;
}

export async function saveYoutubeApiKey(db: Firestore, uid: string, value: string): Promise<void> {
  await setDoc(settingsRef(db, uid), { youtubeApiKey: value.trim() }, { merge: true });
}
